import { useEffect } from "react"

import * as Sentry from "@sentry/react"

import Grid from "@material-ui/core/Grid"
import Paper from "@material-ui/core/Paper"

import { Button } from "@progress/kendo-react-buttons"

import MessageBox from "../../Shared/MessageBox/MessageBox"
import { mockSuccess, mockError } from "../../Shared/Services/DebugApiService"
import { log } from "../../Shared/Services/LogService"

function RegisterUser(props) {
  const {
    backgroundProcessor,
    messageDialogCreate,
    confirmDialogCreate,
    notificationCreate,
    checkAppStatus,
    setAppBarTitle,
  } = props

  useEffect(() => {
    setAppBarTitle("Debug")
  }, [])

  return (
    <Grid container direction="column" style={{ paddingBottom: "1rem" }}>
      <Paper elevation={3} className="MuiPaper-core">
        <Grid container direction="column" wrap="nowrap">
          <Grid item style={{ paddingBottom: "1rem" }}>
            <Button
              iconClass="fas fa-envelope"
              disabled={backgroundProcessor?.tasks}
              onClick={() => {
                messageDialogCreate({
                  title: "The message",
                  content: "This is the message you were looking for.",
                })
              }}
            >
              Open Message Dialog
            </Button>
          </Grid>

          <Grid item style={{ paddingBottom: "1rem" }}>
            <Button
              iconClass="fas fa-check-circle"
              disabled={backgroundProcessor?.tasks}
              onClick={() => {
                confirmDialogCreate({
                  title: "The confirm",
                  content:
                    "You are about to discover the greatest secrets of the universe, " +
                    "do you want to proceed?",
                  onConfirm: () => {
                    log(
                      "l",
                      "Debug confirm",
                      "User confirmed and wants to know the greatest secrets of the universe"
                    )
                  },
                })
              }}
            >
              Open Confirm Dialog
            </Button>
          </Grid>

          <Grid item style={{ paddingBottom: "1rem" }}>
            <Button
              iconClass="fas fa-info-circle"
              disabled={backgroundProcessor?.tasks}
              onClick={() => {
                notificationCreate({
                  severity: "info",
                  message: "Information notification example.",
                })
              }}
            >
              Display Information Snack
            </Button>
          </Grid>

          <Grid item style={{ paddingBottom: "1rem" }}>
            <Button
              iconClass="fas fa-exclamation-triangle"
              disabled={backgroundProcessor?.tasks}
              onClick={() => {
                notificationCreate({
                  severity: "warning",
                  message: "Warning notification example.",
                })
              }}
            >
              Display Warning Snack
            </Button>
          </Grid>

          <Grid item style={{ paddingBottom: "1rem" }}>
            <Button
              iconClass="fas fa-bomb"
              disabled={backgroundProcessor?.tasks}
              onClick={() => {
                notificationCreate({
                  severity: "error",
                  message: "Error notification example.",
                })
              }}
            >
              Display Error Snack
            </Button>
          </Grid>

          <Grid item style={{ paddingBottom: "1rem" }}>
            <Button
              iconClass="fas fa-thumbs-up"
              disabled={backgroundProcessor?.tasks}
              onClick={() => {
                notificationCreate({
                  severity: "success",
                  message: "Success notification example.",
                })
              }}
            >
              Display Success Snack
            </Button>
          </Grid>

          <Grid item style={{ paddingBottom: "1rem" }}>
            <Button
              iconClass="fas fa-envelope"
              disabled={backgroundProcessor?.tasks}
              onClick={() => {
                notificationCreate({
                  severity: "none",
                  message: "No style notification example.",
                })
              }}
            >
              Display No Style Snack
            </Button>
          </Grid>

          <Grid item style={{ paddingBottom: "1rem" }}>
            <Button
              iconClass="fas fa-paper-plane"
              primary
              disabled={backgroundProcessor?.tasks}
              onClick={async () => {
                if (!(await checkAppStatus())) return

                try {
                  backgroundProcessor?.add()

                  const data = await mockSuccess()

                  log("l", "Debug api", data.message)

                  notificationCreate({
                    severity: "success",
                    message: `HTTP Request success!`,
                  })

                  backgroundProcessor?.remove()
                } catch (error) {
                  backgroundProcessor?.remove()

                  log("e", "Debug api", error)

                  notificationCreate({
                    severity: "error",
                    message: `HTTP Request error!`,
                  })
                }
              }}
            >
              Send Success HTTP Request
            </Button>
          </Grid>

          <Grid item style={{ paddingBottom: "1rem" }}>
            <Button
              iconClass="fas fa-paper-plane"
              primary
              disabled={backgroundProcessor?.tasks}
              onClick={async () => {
                if (!(await checkAppStatus())) return

                try {
                  backgroundProcessor?.add()

                  await mockError()

                  notificationCreate({
                    severity: "success",
                    message: `HTTP Request success!`,
                  })

                  backgroundProcessor?.remove()
                } catch (error) {
                  backgroundProcessor?.remove()

                  log("e", "Debug api", error)

                  notificationCreate({
                    severity: "error",
                    message: `HTTP Request error!`,
                  })
                }
              }}
            >
              Send Error HTTP Request
            </Button>
          </Grid>

          <Grid item style={{ paddingBottom: "1rem" }}>
            <Button
              iconClass="fas fa-bomb"
              primary
              disabled={backgroundProcessor?.tasks}
              onClick={() => {
                throw new Error("Debug page throw error with fallback")
              }}
            >
              Throw Error With Fallback
            </Button>
          </Grid>

          <Grid item style={{ paddingBottom: "1rem" }}>
            <Button
              iconClass="fas fa-bomb"
              primary
              disabled={backgroundProcessor?.tasks}
              onClick={() => {
                try {
                  throw new Error("Debug page throw error with no fallback")
                } catch (error) {
                  Sentry.captureException(error, {
                    tags: { context: "debug", noFallback: true },
                  })

                  notificationCreate({
                    severity: "success",
                    message: `Error thrown and captured with success (wow)!`,
                  })
                }
              }}
            >
              Throw Error With No Fallback
            </Button>
          </Grid>

          <Grid item style={{ paddingBottom: "1rem" }}>
            <MessageBox
              severity="info"
              message="Information elevated message box example."
            />
          </Grid>

          <Grid item style={{ paddingBottom: "1rem" }}>
            <MessageBox
              severity="warning"
              message="Warning elevated message box example."
            />
          </Grid>

          <Grid item style={{ paddingBottom: "1rem" }}>
            <MessageBox
              severity="error"
              message="Error elevated message box example."
            />
          </Grid>

          <Grid item style={{ paddingBottom: "1rem" }}>
            <MessageBox
              severity="success"
              message="Success elevated message box example."
            />
          </Grid>

          <Grid item style={{ paddingBottom: "1rem" }}>
            <MessageBox
              severity="none"
              message="No style elevated message box example."
            />
          </Grid>

          <Grid item style={{ paddingBottom: "1rem" }}>
            <MessageBox
              severity="info"
              message="Information outlined message box example."
              variant="outlined"
            />
          </Grid>

          <Grid item style={{ paddingBottom: "1rem" }}>
            <MessageBox
              severity="warning"
              message="Warning outlined message box example."
              variant="outlined"
            />
          </Grid>

          <Grid item style={{ paddingBottom: "1rem" }}>
            <MessageBox
              severity="error"
              message="Error outlined message box example."
              variant="outlined"
            />
          </Grid>

          <Grid item style={{ paddingBottom: "1rem" }}>
            <MessageBox
              severity="success"
              message="Success outlined message box example."
              variant="outlined"
            />
          </Grid>

          <Grid item>
            <MessageBox
              severity="none"
              message="No style outlined message box example."
              variant="outlined"
            />
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  )
}

export default RegisterUser
